import { Chip } from '@cmg/design-system';

import { ParticipationSetStatus } from '../../../../../../../graphql/__generated__';
import {
  participationSetReviewStatusChipColors,
  participationSetReviewStatusLabels,
} from '../../../../../../../types/domain/participation-sets/constants';
import { ParticipationSetsGridColDef, ParticipationSetsRow } from '../../types';

export type Value = ParticipationSetsRow['statusDisplayName'];

export const reviewStatusColDef: ParticipationSetsGridColDef<Value> = {
  field: 'statusDisplayName',
  headerName: 'Review Status',
  filter: 'agSetColumnFilter',
  width: 169,
  // Ideally we come up with a pattern to fetch the status labels from the server and use them here
  filterParams: {
    values: Object.values(ParticipationSetStatus),
    valueFormatter: ({ value }) => participationSetReviewStatusLabels[value] || value,
  },
  cellRenderer: ({ value, data }) => {
    return (
      <Chip
        size="small"
        label={value}
        color={participationSetReviewStatusChipColors[data.status]}
        variant="outlined"
      />
    );
  },
  floatingFilter: true,
  server: {
    filterFieldPath: 'status',
    sortFieldPath: 'status.displayName',
  },
};
